export default __webpack_public_path__ + "static/media/passport.6015184c.svg";